/**
 * Show/hide the full-page preloader printed unconditionally by header.php on every page load.
 */
export function initPreloader() {
	const setLoaded = () => {
		document.querySelectorAll( '.preloader' ).forEach( ( el ) => el.classList.add( 'loaded' ) );
	};

	const setUnloaded = () => {
		document.querySelectorAll( '.preloader' ).forEach( ( el ) => el.classList.remove( 'loaded' ) );
	};

	window.addEventListener( 'load', setLoaded );
	window.addEventListener( 'beforeunload', setUnloaded );
	window.addEventListener( 'pageshow', setLoaded );

	// Runs on the next tick, ahead of the `load` event — the preloader is a brief decorative
	// flash, not a "wait until fully loaded" gate (matches the original theme's behaviour).
	setTimeout( setLoaded );
}
